import { render, staticRenderFns } from "./InputImg.vue?vue&type=template&id=254ab8c3&scoped=true"
import script from "./InputImg.vue?vue&type=script&lang=js"
export * from "./InputImg.vue?vue&type=script&lang=js"
import style0 from "./InputImg.vue?vue&type=style&index=0&id=254ab8c3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ab8c3",
  null
  
)

export default component.exports